import { Label as LabelPrimitive } from 'radix-ui';
import { cn } from '../lib/utils.js';

/** @param {import('react').ComponentProps<typeof LabelPrimitive.Root>} props */
export function Label({ className, ...props }) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        'flex select-none items-center gap-2 text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
}
